import { Typography,Grid,Button} from '@deere/fuel-react';
import {ReactComponent as PrintIcon} from '@deere/ux.brand-foundations/icons/print.svg';
import { useTranslation } from "react-i18next";  
import { getDateFromTimeStamp, getTranslation } from '../utils/utils'

export default function SurveyTitle({ survey, assignment, latestResponse,handlePrint, endDate}) {
    const { t } = useTranslation();
    return (
        <Grid container>
            <Grid item xs={12} paddingLeft={4}>
                <Typography variant="h1" gutterBottom>{getTranslation(survey, 'description')}</Typography>
            </Grid>
            <Grid item sm={8} xs={12} paddingLeft={4}>                
                    <Typography variant="h5" gutterBottom> {t("lbl_survey_current_request")} {assignment.id} - {assignment.supplierName}
                    </Typography> 
                    <Typography variant="h5" gutterBottom> {t("lbl_survey_due_date")} {(endDate)?getDateFromTimeStamp(new Date(endDate)):''} </Typography>
                    <Typography variant="h5" gutterBottom>                    
                       {latestResponse && ` ${t("lbl_last_save")} ${getDateFromTimeStamp(new Date(latestResponse.lastUpdatedTs))} by ${latestResponse.userName ? latestResponse.userName + ' ' + latestResponse.createdBy : latestResponse.createdBy }` }
                    </Typography>
            </Grid>
            <Grid item textAlign={"right"} sm={4} xs={12}  justifyContent="flex-end" alignItems={"flex-end"} alignContent={"flex-end"} paddingRight={4} style={{textAlign:'right',display:'flex', alignContent:"flex-end" }}>
                {handlePrint && 
                    <Button sx={{paddingRight: 100}} variant="secondary" className="d-print-none" startIcon={<PrintIcon size='sm'/>} onClick={handlePrint} >{t('rev_print')}</Button>
                }
            </Grid>
        </Grid>);
}